<template>
  <LoginHolder>
    <h2 class="mb-4 mt-4">Almost there ...</h2>
    <p class="">Please check your email <strong>{{email}}</strong> to confirm your account.</p>
    <p class="pb-4">If <strong>{{email}}</strong> is not your email address, please <strong><router-link class="text-decoration-none btn-color" :to="{ name: 'create-new-account' }">go back</router-link></strong> and enter the correct one.</p>
  </LoginHolder>
</template>

<script>
  import LoginHolder from './LoginHolder.vue'

  export default {
    name: 'ConfirmRegistration',
    data: () => ({
      email: ''
    }),
    methods: {
    },
    mounted() {
      if(this.$route.query.email){
        this.email = this.$route.query.email
        this.$router.push({ name: 'confirm-registration' })
      }
    },
    components: {
      LoginHolder
    },
  }
</script>
